import classNames from 'classnames'
import { IconType } from 'react-icons/lib'
import { useParams } from 'react-router-dom'

import { commonIcons } from '@apps-common/config/icons'
import { CARD_RADIUS_STYLES } from '@apps-common/config/styles'

interface IProps {
  unitId: string
  count?: number
  label: string
  Icon: IconType
  bgClasses: string
  textClasses: string
  bgSecondaryClasses: string
  textSecondaryClasses: string
  bgTertiaryClasses: string
  bgActiveClasses: string
  disabled?: boolean
  callback: () => void
}

export const UnitManageCard: React.FC<IProps> = ({
  count,
  label,
  Icon,
  bgClasses,
  textClasses,
  bgSecondaryClasses,
  textSecondaryClasses,
  bgTertiaryClasses,
  bgActiveClasses,
  disabled,
  callback
}) => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()
  const ArrowIcon = commonIcons.arrowAngled

  const value = count && count > 0 ? count : <commonIcons.dash />

  return (
    <button
      type='button'
      className={classNames(
        'relative w-full pt-[100%] flex flex-col',
        CARD_RADIUS_STYLES,
        bgClasses,
        // disabled && bgClasses,
        // !disabled && bgActiveClasses,
        disabled && 'opacity-50 hover:cursor-default'
      )}
      onClick={() => {
        if (disabled) return

        callback()
      }}
    >
      <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center'>
        <div className='w-full'>
          <div className={classNames('relative w-[50%] pt-[50%] rounded-full mx-auto', bgSecondaryClasses)}>
            <div className={classNames('absolute rounded-full top-[-6.5px] right-[-6.5px] overflow-hidden', bgSecondaryClasses)}>
              <div className={classNames('relative z-[2] p-[5px] w-full h-full', textSecondaryClasses, bgTertiaryClasses)}>
                <Icon className='text-[0.9rem]' />
              </div>
            </div>
            <div className={classNames('absolute top-0 left-0 w-full h-full flex items-center justify-center', textClasses)}>
              <div>{value}</div>
            </div>
          </div>
          <div className={classNames('flex items-center justify-between gap-[3px] text-[0.85em] jost grow mx-3 sm:mx-2 mt-2', textClasses)}>
            <p>{label}</p>
            <div className={classNames('flex items-center justify-center p-[2px] sm:p-1 rounded-full', bgSecondaryClasses)}>
              <ArrowIcon />
            </div>
          </div>
        </div>
      </div>
    </button>
  )
}
